'use client';

import { TxParams } from '@velocity-exchange/sdk';

/**
 * Maps UI's tx params to Vault SDK's tx params format
 */
export const mapTxParamsToVaultTxParams = (txParams: TxParams) => {
	return {
		cuLimit: txParams.computeUnits,
		cuPriceMicroLamports: txParams.computeUnitsPrice,
	};
};
